import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Viewer from './pages/Viewer';
import Verify from './pages/Verify';
import "./assets/img/crimsonlogiclogo.png";
import "./css/custom.css";
import { useEffect } from 'react';

function App() {
    const isProtected = JSON.parse(process.env.REACT_APP_IS_PROTECTED);

    useEffect(() => {
        if (!isProtected) return;

        // Block right-click
        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        // Block Ctrl+P
        const handleKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p") {
            e.preventDefault();
            alert("Printing is disabled.");
        }
        };
        document.addEventListener("keydown", handleKeyDown);

        document.body.classList.add("protected-mode");

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
            document.removeEventListener("keydown", handleKeyDown);
            document.body.classList.remove("protected-mode");
        };
    }, [isProtected]);

    return (
        <div>
            <div>
                <div className='App'>
                    <BrowserRouter basename={process.env.PUBLIC_URL}>
                        <Routes>
                            <Route path="/" element={<Verify />} />
                            <Route path="viewer" element={<Viewer />} />
                        </Routes>
                    </BrowserRouter>
                </div>
            </div>
        </div>
    );
}

export default App;
